import { Drawer } from "antd";
import { GLOB } from "src/util/Glob";
import './GlobalHealthStatus.less';
import StateTabs from "./StateTabs";

const HealthStatusDrawer = () => {
  const handleClose = () => GLOB.setAppState({ isHsOpen: false });

  return (
    (<Drawer
      title='Global Health Status'
      open={GLOB.getAppState().isHsOpen}
      onClose={handleClose}
      rootClassName='wrapper-glob-health-status'
    >
      <StateTabs />
    </Drawer>)
  );
};

export default HealthStatusDrawer;